export default __webpack_public_path__ + "static/media/hardlight.4df54ea5.png";